import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import PropTypes from "prop-types";

class RatingInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
    };

    this.toggleExpand = this.toggleExpand.bind(this);
  }

  toggleExpand() {
    this.setState({
      isExpanded: !this.state.isExpanded,
    });
  }

  render() {
    const { intl } = this.props;
    // Get the HTML content from the translation
    const ratingInfoHtml = intl.formatMessage({ id: "WA.TechSkill.RatingInfo" });
    
    return (
      <div className="rating-info-container">
        <div className="rating-info-header" onClick={this.toggleExpand}>
          <h5>
            <FormattedMessage id="WA.TechSkill.RatingInfoTitle" />
          </h5>
          <i
            className={`fa ${
              this.state.isExpanded ? "fa-chevron-up" : "fa-chevron-down"
            }`}
          />
        </div>

        {this.state.isExpanded && (
          <div className="rating-info-content">
            <p 
              dangerouslySetInnerHTML={{ __html: ratingInfoHtml }}
            />
          </div>
        )}
      </div>
    );
  }
}

RatingInfo.propTypes = {
  intl: PropTypes.object.isRequired
};

export default injectIntl(RatingInfo);
